<div
  class="coverage-badge"
  [ngClass]="badgeType()"
  [class.skeleton-loader]="isUpdating()"
>
  @if (hasImage()) {
    <div class="coverage-badge-icon">
      @if (badgeType() === coverageBadgeType.IN_NETWORK) {
        <img src="/assets/check_gear.svg" alt="Check Gear" />
      } @else {
        <iris-icon
          [size]="iconSizes.MD"
          name="info"
          [color]="iconColors.DANGER"
        ></iris-icon> 
      }
    </div>
  }
  <div
    class="coverage-badge-text"
    data-test="coverage-badge-text"
  >{{ badgeText() }}</div>
</div>
